import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import App from '../App'
import { PrivilegedAgentRedirect } from '../components/PrivilegedAgentRedirect'
import { AuthProvider } from '../context/AuthContext'
import ChatHomePage from '../pages/ChatHomePage'
import ChatPage from '../pages/ChatPage'
import SettingsPage from '../pages/SettingsPage'
import ProtectedRoute from '../routes/ProtectedRoute'

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <AuthProvider>
        <App>
          <Routes>

            {/* Root route - redirect to privileged agent */}
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <PrivilegedAgentRedirect />
                </ProtectedRoute>
              }
            />

            {/* Settings Page */}
            <Route
              path="/settings"
              element={
                <ProtectedRoute>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />

            {/* Agent-specific home page */}
            <Route
              path="/a/:agentId"
              element={
                <ProtectedRoute>
                  <ChatHomePage />
                </ProtectedRoute>
              }
            />

            {/* Chat Detail Page (legacy route for backward compatibility) */}
            <Route
              path="/c/:chatId"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />

            {/* Agent-specific chat page */}
            <Route
              path="/a/:agentId/c/:chatId"
              element={
                <ProtectedRoute>
                  <ChatPage />
                </ProtectedRoute>
              }
            />

            {/* Fallback redirect */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </App>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default AppRoutes
